import React,{useState,useContext} from 'react'
import Web from "../../../../Icons/Web"
import Tab from "../../../../Icons/Tab"
import Mobile from "../../../../Icons/Mobile"
import "./DeviceTypeSelector.css"
import {AppContext} from '../../../../Resources/CanvasContextFile';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LongMenu from '../LongMenu/LongMenu';
import CustomizeBreakpoint from '../CustomizeBreakpoint/CustomizeBreakpoint';
import BreakpointsDevices from '../BreakpointDevices/BreakpointsDevices';
import {useDispatch,addContexts,useSelector} from "../../../../Redux"

import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import { GetStateFromData } from '../../../CustomHooks/CustomHooks'

const useStyles = makeStyles({
  tooltip: {
    maxWidth: "160px",
    // maxHeight: "96px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
});


const DeviceTypeSelector = ({props}) => {

	const classes = useStyles();
    const { t } = useTranslation(["styles", "translation"]);

    const [selectedDevice, setSelectedDevice]=useState(undefined);


    let widthOfCanvasArea=0 ;
    
    const contexts = GetStateFromData(props.containerId);

   const {updateJson,deleteControl,changeCanvasLayout,setWidthOfCanvas}=contexts.contexts;

   const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson;

   function agentHas(keyword) {
    return window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
    }

 let isSafariBrowser = function isSafari() {
  return (!!window.ApplePaySetupFeature || !!window.safari) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");
  }
  


    const handleDevice=(e) =>{
        if(props.formdata.style && props.formdata.style["CurrentDevice"])
        {
            props.formdata.style["CurrentDevice"]["DeviceWidth"]=0;
            updatedComponentInFormState();
        }
        const target=e.target.getAttribute("name");
        const colLayout=e.target.getAttribute("value");
        // setWidthOfCanvas(parseInt(deviceJson[index].deviceWidth));
        if(target==="tablet"){
            if(props.formdata.style && props.formdata.style["WidthOfTablet"]){
              setWidthOfCanvas(props.formdata.style["WidthOfTablet"]);
            }
            else{
              setWidthOfCanvas(754);
            }
        }
        else if(target==="web"){
            if(props.formdata.style && props.formdata.style["WidthOfWeb"]){
              isSafariBrowser() ? setWidthOfCanvas(1922): setWidthOfCanvas(props.formdata.style["WidthOfWeb"]);
                }else{
                  isSafariBrowser() ? setWidthOfCanvas(1922): setWidthOfCanvas(1240);
                }
        }
        else if(target==="mobile"){
            if(props.formdata.style && props.formdata.style["WidthOfMobile"]){
                setWidthOfCanvas(props.formdata.style["WidthOfMobile"]);
                }else{
                    setWidthOfCanvas(440);
                }
        }
        props.setDevice(target);
        changeCanvasLayout(colLayout,target,props.device);
    }   
    
    return (
    <div className="deviceTypeSelector" role='region' aria-label="Device Type Selector Section">
      <Tooltip
        title={t(`translation:${"Device Web"}`)}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        placement={"bottom-start"}
        arrow
      >
        <div
        tabIndex={0}
          className={
            props.device === "web"
              ? "deviceTypeSelector_sub_active deviceTypeSelector_sub"
              : "deviceTypeSelector_sub"
          }
          value="3"
          name="web"
          onKeyDown={(e) => {if(e.key === "Enter"){handleDevice(e)}}}
          onClick={handleDevice}
          style={{borderRadius: "2px 0 0 2px"}}
        >
          <Web selected={props.device === "web"} />
        </div>
      </Tooltip>
      <Tooltip
        title={t(`translation:${"Device Tab"}`)}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        placement={"bottom-start"}
        arrow
      >
        <div
        tabIndex={0}
          className={
            props.device === "tablet"
              ? "deviceTypeSelector_sub_active deviceTypeSelector_sub"
              : "deviceTypeSelector_sub"
          }
          value="2"
          name="tablet"
          onKeyDown={(e) => {if(e.key === "Enter"){handleDevice(e)}}}
          onClick={handleDevice}
        >
          <Tab selected={props.device === "tablet"} />
        </div>
      </Tooltip>
      <Tooltip
        title={t(`translation:${"Device Mobile"}`)}
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        placement={"bottom-start"}
        arrow
      >
        <div
          className={
            props.device === "mobile"
              ? "deviceTypeSelector_sub_active deviceTypeSelector_sub deviceTypeSelector_sub"
              : " deviceTypeSelector_sub deviceTypeSelector_sub_last"
          }
          value="1"
          tabIndex={0}
          name="mobile"
          onKeyDown={(e) => {if(e.key === "Enter"){handleDevice(e)}}}
          onClick={handleDevice}
          style={{borderRadius: "0 2px 2px 0"}}
        >
          <Mobile selected={props.device === "mobile"} />
        </div>
      </Tooltip>

      {/* <LongMenu/> */}
      <div className="breakPointClass" id="breakpointsMoreOptions">
        <CustomizeBreakpoint
          selectedDevice={selectedDevice}
          setSelectedDevice={setSelectedDevice}
          containerId={props.containerId}
          formdata={props.formdata}
          setDevice={props.setDevice}
        />
      </div>
      {/* <div className="WClass">{t(`translation:${"Width"}`)}</div>
      <div className="DevicesClass">
        <BreakpointsDevices
        containerId={props.containerId}
          formdata={props.formdata}
          setDevice={props.setDevice}
          device={props.device}
        />
      </div> 
      */}
    </div>
  );
};

export default DeviceTypeSelector
